import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';

import { DataTable } from '@unified-checkout/design-system';

import { REACH_PAGE_EVENTS } from '@app/dashboard/constants/tracking_events/reach';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';
import { useLangStore } from '@app/dashboard/store/lang';
import { useTestLiveModeStore } from '@app/dashboard/store/testLiveMode';
import { MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';
import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import { TABLE_HEADER_DEFINITIONS } from '@app/dashboard/constants/reach/campaigns';
import { fetchCampaigns } from '@app/dashboard/services/inner_layout/reach/campaigns';

import styles from './TableListing.module.scss';

const TableListing = () => {
  const { t } = useTranslation();
  const screenWidth = useScreenWidth();
  const navigate = useNavigate();

  const { lang } = useLangStore();
  const { isLive } = useTestLiveModeStore();

  const isMobile = screenWidth <= MOBILE_BREAKPOINT;
  const columns = TABLE_HEADER_DEFINITIONS(t);

  const queryKeys = useMemo(
    () => [QUERY_KEYS.REACH_GET_CAMPAIGNS, isLive],
    [isLive]
  );

  const handleTableRowClick = (rowData: any) => {
    navigate(`/reach/campaign/${rowData.id}`);
    amplitude.track(REACH_PAGE_EVENTS.CAMPAIGNS_PAGE.CAMPAIGN_ROW_OPENED, {
      campaignId: rowData.id,
    });
  };

  return (
    <div className={styles['table-listing']}>
      <DataTable
        lang={lang}
        tableBody={{
          lang: lang,
          tableId: '',
          dataLocation: 'data.data.results',
          columnsMap: columns,
          rowClickHandler: handleTableRowClick,
        }}
        pagination={{
          hideLabels: isMobile,
          type: 'cursor_based',
          dataLocation: {
            next: 'data.data.next',
            prev: 'data.data.previous',
          },
          isMobile: isMobile,
        }}
        queries={{
          queryKeys: queryKeys,
          queryFunction: fetchCampaigns,
        }}
        emptyState={{
          text: t('innerLayout.reach.campaigns.table.body.noCampaignsYet'),
          description: t(
            'innerLayout.reach.campaigns.table.body.noCampaignsHint'
          ),
        }}
      />
    </div>
  );
};

export default TableListing;
